import { render, staticRenderFns } from "./PromoTemplateA6.vue?vue&type=template&id=9eef6ffc"
import script from "./PromoTemplateA6.vue?vue&type=script&lang=js"
export * from "./PromoTemplateA6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports